export default __webpack_public_path__ + "static/media/img-banner.ac767fea.png";